/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import { useInputState } from '@infotrack/presentacion-utilitarios/hooks';
import {
    manejadorDialogoGlobal,
    manejadorIndicadorCargaGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import IClasesTecnicas from 'Infotrack@Modelos/smartStock/clasesTecnicas/entidades/clasesTecnicas';
import { IEstadoGlobal } from 'Infotrack@Reductores/interfacesReductores';
import React from 'react';
import { connect } from 'react-redux';
import ClasesTecnicasCM from '../controladorModelo/clasesTecnicasCM';
import { IFormularioClasesTecnicasCVProps } from '../interfaces';
import { acciones, IEstadoClasesTecnicas } from '../reductorClasesTecnicas';
import FormularioClasesTecnicasVista from '../vista/formularioClasesTecnicasVista';

const estadoInicial: IClasesTecnicas = {
    EmpresaId: '',
    ClaseTecnicaDescripcion: '',
    Estado: 1,
    AgenciaId: '',
};
const clasesTecnicasCM = new ClasesTecnicasCM();

const FormularioClasesTecnicasCV: React.FunctionComponent<IFormularioClasesTecnicasCVProps> = ({
    IdEmpresa,
    IdAgencia,
}) => {
    const [{ estadoFormulario, tipoFormulario, entidadClasesTecnicas }, dispatch] = useProveedor<
        IEstadoClasesTecnicas
    >();
    const { alCambiarValor, setValor, reiniciar, valor } = useInputState<IClasesTecnicas>(estadoInicial);

    React.useEffect(() => {
        if (entidadClasesTecnicas && tipoFormulario !== TipoFormulario.Creacion) {
            setValor(entidadClasesTecnicas);
        } else {
            reiniciar();
        }
    }, [entidadClasesTecnicas]);

    const cerrarFormulario = () => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: null });
    };
    const confirmarCreacionEdicionClasesTecnicas = () => {
        if (clasesTecnicasCM.validarEntidad(valor)) {
            manejadorDialogoGlobal({
                accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
                accionConfirmar: crearEditarClasesTecnicas,
                estado: true,
                mensaje: (
                    <Texto
                        id={
                            tipoFormulario === TipoFormulario.Creacion
                                ? 'alerta.confirmacionCreacion'
                                : 'alerta.confirmacionEdicion'
                        }
                    />
                ),
                mostrarCancelar: true,
                tipoDialogo: 'Advertencia',
                titulo: <Texto id="titulo.advertencia" />,
            });
        }
    };

    const crearEditarClasesTecnicas = () => {
        manejadorDialogoGlobal({ estado: false });
        manejadorIndicadorCargaGlobal(true);
        if (tipoFormulario === TipoFormulario.Creacion) {
            clasesTecnicasCM
                .crearClasesTecnicas({
                    ...valor,
                    EmpresaId: IdEmpresa,
                    AgenciaId: IdAgencia,
                    Estado: valor.Estado === true || valor.Estado === 1 ? 1 : 0,
                })
                .then(() => {
                    cerrarFormulario();
                    manejadorIndicadorCargaGlobal(false);
                    dispatch({ type: acciones.RECARGAR_TABLA });
                });
        } else {
            clasesTecnicasCM
                .editarClasesTecnicas({
                    ...valor,
                    EmpresaId: IdEmpresa,
                    AgenciaId: IdAgencia,
                    Estado: valor.Estado === true || valor.Estado === 1 ? 1 : 0,
                })
                .then(() => {
                    cerrarFormulario();
                    manejadorIndicadorCargaGlobal(false);
                    dispatch({ type: acciones.RECARGAR_TABLA });
                });
        }
    };

    return (
        <FormularioClasesTecnicasVista
            accionCrearEditar={confirmarCreacionEdicionClasesTecnicas}
            cambiarInfoFomulario={alCambiarValor}
            clasesTecnicas={valor}
            cerrarFormulario={cerrarFormulario}
            estadoFormulario={estadoFormulario}
            tipoFormulario={tipoFormulario}
        />
    );
};

const estadoAPropiedades = ({
    estadoAutenticacion: { usuarioInformacion, agenciaActual },
}: IEstadoGlobal): IFormularioClasesTecnicasCVProps => ({
    IdEmpresa: usuarioInformacion!.IdEmpresa,
    IdAgencia: agenciaActual!.IdAgencia,
});

export default connect<IFormularioClasesTecnicasCVProps, null, any, IEstadoGlobal>(
    estadoAPropiedades,
    null
)(FormularioClasesTecnicasCV);
